import { useEffect, useState } from "react";

/**
 * This codebase's first debounce utility (Story 9.2, judgement call 2).
 * `DocumentsList.tsx`'s own `filename` filter fires a request on every
 * keystroke — the right choice there, one entity, one query. The search
 * overlay fans a single keystroke out into four entity queries server-side
 * (`app.domain.search.search`'s own per-entity loop), so a short debounce
 * on the value before it becomes a React Query key smooths that without
 * being perceptible as a delay (AC: "results appear as they type").
 *
 * Generic and genuinely reusable — nothing about it is search-specific;
 * `value` can be any type, not just a string. Returns `value` itself,
 * unchanged, until `delayMs` has passed with no further change, then
 * updates to the latest value in one step (never an intermediate one).
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
